import {
  AccountCircleRounded as AccountCircleRoundedIcon,
  BusinessRounded as BusinessRoundedIcon,
  HomeRounded as HomeRoundedIcon,
  LayersRounded as LayersRoundedIcon,
  PeopleRounded as PeopleRoundedIcon,
  PersonAddRounded as PersonAddRoundedIcon,
  SensorsRounded as SensorsRoundedIcon,
  SettingsSuggestRounded as SettingsSuggestRoundedIcon,
  ShieldRounded as ShieldRoundedIcon,
  Timeline as TimelineIcon,
  WarningRounded as WarningRoundedIcon,
  WifiRounded as WifiRoundedIcon
} from '@mui/icons-material'
import { Divider, ListItemIcon, ListItemText, MenuItem, MenuList } from '@mui/material'
import { grey } from '@mui/material/colors'
import { t } from 'i18next'
import { Link } from 'react-router-dom'

import { useAuth } from '../../Shared/Contexts/AuthContext.jsx'
import Can from '../Can/Can.jsx'

const ManagementMenu = () => {
  const {
    currentUser: { isSuperAdmin, isCurrentOrganizationLocked },
    refreshSelfOrganizations
  } = useAuth()

  return (
    <MenuList>
      <MenuItem
        id="menu-home"
        component={Link}
        onClick={refreshSelfOrganizations}
        to="/">
        <ListItemIcon sx={{ color: grey[500] }}>
          <HomeRoundedIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>{t('common.home')}</ListItemText>
      </MenuItem>

      <MenuItem
        id="menu-profile"
        component={Link}
        onClick={refreshSelfOrganizations}
        to="/management/profile">
        <ListItemIcon sx={{ color: grey[500] }}>
          <AccountCircleRoundedIcon fontSize="small" />
        </ListItemIcon>
        <ListItemText>{t('common.myProfile')}</ListItemText>
      </MenuItem>

      {!isCurrentOrganizationLocked && (
        <>
          <Divider />

          <Can action="organizations_r">
            <MenuItem
              id="menu-organizations"
              component={Link}
              onClick={refreshSelfOrganizations}
              to="/management/organizations">
              <ListItemIcon sx={{ color: grey[500] }}>
                <LayersRoundedIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>{t('common.organizations')}</ListItemText>
            </MenuItem>
          </Can>

          <Can
            action="organizations_profiles_r"
            expression={() => isSuperAdmin}>
            <MenuItem
              id="menu-organization-profiles"
              component={Link}
              onClick={refreshSelfOrganizations}
              to="/management/organization-profiles">
              <ListItemIcon sx={{ color: grey[500] }}>
                <BusinessRoundedIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>{t('organizationProfiles.title')}</ListItemText>
            </MenuItem>
          </Can>

          {isSuperAdmin && <Divider />}

          <Can action="users_c">
            <MenuItem
              id="menu-invites"
              component={Link}
              onClick={refreshSelfOrganizations}
              to="/management/invites">
              <ListItemIcon sx={{ color: grey[500] }}>
                <PersonAddRoundedIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>{t('common.invites')}</ListItemText>
            </MenuItem>

            <Divider />
          </Can>

          <Can action="devices_r">
            <MenuItem
              id="menu-devices"
              component={Link}
              onClick={refreshSelfOrganizations}
              to="/management/devices">
              <ListItemIcon sx={{ color: grey[500] }}>
                <SensorsRoundedIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>{t('common.devices')}</ListItemText>
            </MenuItem>
          </Can>

          <Can action="automations_r">
            <MenuItem
              id="menu-automations"
              component={Link}
              onClick={refreshSelfOrganizations}
              to="/management/automations">
              <ListItemIcon sx={{ color: grey[500] }}>
                <SettingsSuggestRoundedIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>{t('common.automations')}</ListItemText>
            </MenuItem>
          </Can>

          <Can action="automations_r">
            <MenuItem
              id="menu-events"
              component={Link}
              onClick={refreshSelfOrganizations}
              to="/management/events">
              <ListItemIcon sx={{ color: grey[500] }}>
                <WarningRoundedIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>{t('common.events')}</ListItemText>
            </MenuItem>
          </Can>

          <Divider />

          <Can
            action="gateways_r"
            expression={() => isSuperAdmin}>
            <MenuItem
              id="menu-gateways"
              component={Link}
              onClick={refreshSelfOrganizations}
              to="/management/gateways">
              <ListItemIcon sx={{ color: grey[500] }}>
                <WifiRoundedIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>{t('common.gateways')}</ListItemText>
            </MenuItem>
          </Can>

          {isSuperAdmin && <Divider />}

          <Can action="users_u">
            <MenuItem
              id="menu-users"
              component={Link}
              onClick={refreshSelfOrganizations}
              to="/management/users">
              <ListItemIcon sx={{ color: grey[500] }}>
                <PeopleRoundedIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>{t('common.users')}</ListItemText>
            </MenuItem>
          </Can>

          <Can
            action="roles_u"
            expression={() => isSuperAdmin}>
            <MenuItem
              id="menu-roles"
              component={Link}
              onClick={refreshSelfOrganizations}
              to="/management/roles">
              <ListItemIcon sx={{ color: grey[500] }}>
                <ShieldRoundedIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>{t('common.roles')}</ListItemText>
            </MenuItem>
          </Can>

          <Can
            action="users_r"
            expression={() => isSuperAdmin}>
            <MenuItem
              id="menu-statistics"
              component={Link}
              onClick={refreshSelfOrganizations}
              to="/management/statistics">
              <ListItemIcon sx={{ color: grey[500] }}>
                <TimelineIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>{t('common.statistics')}</ListItemText>
            </MenuItem>
          </Can>
        </>
      )}
    </MenuList>
  )
}

export default ManagementMenu
